<template>
  <div>
    <div class="db relative z--1 navigation" v-bind:class="{ show: navIsOpen }">
      <div class="db fixed z-999 absolute--fill ph2 ph0-ns flex flex-column items-center content-center justify-center navigation-content">
        <transition name="bounce">
          <div class="db relative z-999 center w-100 mw-425px" v-show="navIsOpen">
            <div class="db absolute z-2 left-0 mt2 ml1 grow pointer menu-icon-close" alt="close modal" v-on:click="closeNav()">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="db relative center w-100 h-100 overflow-hidden">
              <section class="db relative center w-100 h-100 vh-88-xs h-modal-ns ph3 pt0 pt3-ns bg-white br2">
                <div class="flex relative center h-100 flex-column items-center content-center justify-center">
                  <div class="db relative center w-100 h-auto">
                    <div class="flex flex-column mv0 center items-center justify-center content-center">
                      <router-link class="db w-50 f3 mv2 mh3 tc pointer no-underline is-bebas ttu nav-bg-line-hover" to="/home/" v-on:click.native="closeNav()">Home</router-link>
                      <router-link class="db w-50 f3 mv2 mh3 tc pointer no-underline is-bebas ttu nav-bg-line-hover" to="/about/" v-on:click.native="closeNav()">About</router-link>
                      <router-link class="db w-50 f3 mv2 mh3 tc pointer no-underline is-bebas ttu nav-bg-line-hover" to="/projects/" v-on:click.native="closeNav()">Projects</router-link>
                      <router-link class="db w-50 f3 mv2 mh3 tc pointer no-underline is-bebas ttu nav-bg-line-hover" to="/gallery/" v-on:click.native="closeNav()">Gallery</router-link>
                      <router-link class="db w-50 f3 mv2 mh3 tc pointer no-underline is-bebas ttu nav-bg-line-hover" to="/partners/" v-on:click.native="closeNav()">Partners</router-link>
                    </div>
                    <div class="db relative center mt3 mw21rem">
                      <social-icons></social-icons>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </transition>
        <div class="db absolute absolute--fill bg-black o-70" v-on:click="closeNav()"></div>
      </div>
    </div>
    <!-- fixed header -->
    <div class="db fixed top-0 w-100 z-998 fixed-header">
      <div class="db relative container-fluid relative ph2 ph3-ns pv2">
        <div class="flex relative flex-row items-center">
          <a class="flex relative flex-row items-center ph2 pt2 pb1 h42px pointer grow btn-generic menu-icon-wrapper" v-on:click="menuIconIsClicked = !menuIconIsClicked; openNav();" v-bind:class="{ isClicked: navIsOpen }">
            <div class="db absolute left-0 menu-icon pointer">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Signup from './signup.vue';
import SocialIcons from './social-icons.vue';
import { bus } from '../assets/js/src/main';
export default {
  template: '#app-header-template',
  //props: ['navIsOpen'],
  components: {
    'signup': Signup,
    'social-icons': SocialIcons
  },
  data () {
    return {
      menuIconIsClicked: false,
      navIsOpen: false,
      isTicketsPage: false
    }
  },
  methods: {
    openNav() {
      this.navIsOpen = true;
    },
    closeNav() {
      this.navIsOpen = false;
    }
  },
  beforeCreate() {
    //
  },
  created() {
    bus.$on('isTicketsPageBus', (data) => {
      this.isTicketsPage = true;
    })
  },
  updated(){
    //console.log('app-header - updated', this.$route.path)
    if (this.$route.path === '/tickets/') {
      this.isTicketsPage = true;
    }
    else {
      this.isTicketsPage = false;
    }
  }
}
</script>